export const NextDoubleArrowIcon = () => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M8.25 14.25L12.75 9L8.25 3.75" stroke="#3B3F5C" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.5" d="M5.24988 14.25L9.74991 9L5.24988 3.75" stroke="#3B3F5C" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}